(function () {
  const picker = document.querySelector("variant-picker");
  if (!picker) return;

  const sectionId = picker.dataset.section;
  const variantsJsonEl = document.getElementById(
    `product-variants-json-${sectionId}`,
  );
  const variants = variantsJsonEl ? JSON.parse(variantsJsonEl.textContent) : [];

  function getSelectedOptions() {
    return Array.from(
      picker.querySelectorAll('input[type="radio"]:checked'),
    ).map((input) => input.value);
  }

  function findMatchingVariant(selectedOptions) {
    return variants.find((variant) => {
      const optionValues = [
        variant.option1,
        variant.option2,
        variant.option3,
      ].filter(Boolean);
      return optionValues.every((opt, idx) => opt === selectedOptions[idx]);
    });
  }

  function formatMoney(cents, currency = "LKR") {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
    }).format((cents || 0) / 100);
  }

  function updatePriceUI(variant) {
    const wrapper = document.querySelector("[data-price-wrapper]");
    if (!wrapper || !variant) return;

    const regularPrice = wrapper.querySelector(
      "[data-regular-price], [data-sale-price]",
    );
    if (regularPrice)
      regularPrice.textContent = formatMoney(
        variant.price,
        "LKR",
      );

  
  }

  function updateUrl(variant) {
    const url = new URL(window.location.href);
    url.searchParams.set("variant", variant.id);
    history.replaceState({}, "", url.toString());
  }

  picker.addEventListener("change", (event) => {
    const form = document.getElementById(`product-form-${sectionId}`);
    const variantIdInput = form?.querySelector("[data-variant-id]");
    const addToCartBtn = form?.querySelector("[data-add-to-cart]");

    const selectedOptions = getSelectedOptions();

    // Update selected option labels
    picker.querySelectorAll("[data-option-selected]").forEach((label, idx) => {
      if (selectedOptions[idx]) label.textContent = selectedOptions[idx];
    });

    // Toggle selected classes
    picker
      .querySelectorAll(".variant-btn")
      .forEach((btn) => btn.classList.remove("is-selected"));
    event.target.closest(".variant-btn")?.classList.add("is-selected");

    const variant = findMatchingVariant(selectedOptions);
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;
    if (addToCartBtn) {
      addToCartBtn.disabled = !variant.available;
      addToCartBtn.textContent = variant.available ? "Add to Cart" : "Sold Out";
    }

    updatePriceUI(variant);
    updateUrl(variant);

    if (variant.featured_image && variant.featured_image.position) {
      const targetIndex = variant.featured_image.position - 1;
      const image = document.querySelector(
        `[data-gallery-thumb="${targetIndex}"]`,
      );
      image?.dispatchEvent(new Event("click"));
    }
  });
})();
